// @flow
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { routerMiddleware } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
import { initialize, addTranslation } from "react-localize-redux";

import { locale } from "../Locales/index";
import rootReducer from "../Reducers/index";
import rootSaga from "../Sagas/index";

export const history = createHistory();
const sagaMiddleware = createSagaMiddleware();

const initialState = {};
const enhancers = [];
const middlewares = [sagaMiddleware, routerMiddleware(history)];

const languages = ["en", "tr"];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middlewares), ...enhancers);

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
);

sagaMiddleware.run(rootSaga);

store.dispatch(initialize(languages, { defaultLanguage: "tr" }));
store.dispatch(addTranslation(locale));

export default store;



// WEBPACK FOOTER //
// ./src/Store/store.js